import React from 'react';
import { Link } from 'react-router-dom';

// Footer component for the public portal, admin and customer dashboard
const Footer = ({ portal = 'public' }) => {
  return (
    <footer className="bg-white py-4 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm text-gray-500">
          Copyright © 2025 Grey Imports Australia Pty Ltd. All Rights Reserved.{' '}
          <Link
            to="/privacy-policy"
            state={{ portal }}
            className="text-blue-700 hover:text-blue-800"
          >
            Privacy Policy
          </Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
